import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Calendar, Bell, X, LogOut } from 'lucide-react';

const Sidebar = ({ isOpen, setIsOpen, isDesktop }) => {
    const config = window.reactPress || window.rpVars || {};
    const siteUrl = config.api?.rest_url?.split('/wp-json')[0] || '/';

    const navItems = [
        { name: 'Dashboard', icon: <LayoutDashboard size={20} />, path: '/' },
        { name: 'My Students', icon: <Users size={20} />, path: '/students' },
        { name: 'Scheduling & Diary', icon: <Calendar size={20} />, path: '/scheduling' },
        { name: 'Notifications', icon: <Bell size={20} />, path: '/notifications' },
    ];

    return (
        <aside style={{
            width: 'var(--sidebar-width)',
            backgroundColor: 'var(--secondary)',
            color: 'var(--white)',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            left: 0,
            top: 0,
            zIndex: 50,
            transform: isDesktop || isOpen ? 'translateX(0)' : 'translateX(-100%)',
            transition: 'transform 0.3s ease'
        }}>
            <div style={{ padding: '24px', borderBottom: '1px solid rgba(255,255,255,0.1)', position: 'relative' }}>
                {!isDesktop && (
                    <button
                        onClick={() => setIsOpen(false)}
                        style={{
                            position: 'absolute',
                            right: '16px',
                            top: '24px',
                            background: 'none',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        <X size={20} />
                    </button>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        backgroundColor: 'var(--primary)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'var(--secondary)',
                        fontWeight: 'bold'
                    }}>S</div>
                    <div>
                        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>Safety Driver</div>
                        <div style={{ fontSize: '10px', color: '#ccc', letterSpacing: '1px' }}>TRAINING</div>
                    </div>
                </div>
            </div>

            <nav style={{ padding: '24px 0', flex: 1 }}>
                {navItems.map((item) => (
                    <NavLink
                        key={item.name}
                        to={item.path}
                        style={({ isActive }) => ({
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '12px 24px',
                            color: isActive ? 'var(--primary)' : 'var(--white)',
                            textDecoration: 'none',
                            borderLeft: isActive ? '4px solid var(--primary)' : '4px solid transparent',
                            backgroundColor: isActive ? 'rgba(255, 255, 255, 0.05)' : 'transparent',
                            transition: 'all 0.2s ease',
                            marginBottom: '4px'
                        })}
                    >
                        {item.icon}
                        <span style={{ fontSize: '15px' }}>{item.name}</span>
                    </NavLink>
                ))}
            </nav>

            <div style={{ padding: '24px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
                <button
                    onClick={() => window.location.href = siteUrl}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px 16px',
                        width: '100%',
                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                        color: '#ef4444',
                        borderRadius: '12px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        transition: 'all 0.2s ease',
                        border: '1px solid rgba(239, 68, 68, 0.2)'
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.2)';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)';
                    }}
                >
                    <LogOut size={18} />
                    Logout
                </button>
                <div style={{ fontSize: '10px', color: '#888', marginTop: '16px', textAlign: 'center' }}>v1.0.0 Instructor App</div>
            </div>
        </aside>
    );
};

export default Sidebar;
